module.exports = __webpack_public_path__ + "img/food plate knife fork.e4617860.svg";